import React from "react";
import { Button, Card } from "../../../../common";
import { Link } from "react-router-dom";

export const VATInformation = ({ company }) => {
  return (
    <Card classes="rounded-xl bg-white p-6 mb-6">
      <h4 className="text-f18 text-primary mb-4 font-semibold text-left">
        Value Added Tax (VAT) Information
      </h4>
      <div className="p-8 vat rounded-xl flex flex-col flex-row sm:grid grid-cols-3 gap-4 ">
        <div className="text-white text-left">
          <strong>Tax Registration Number</strong>
          <br />
          <span className="text-f14">{company?.TRN_no}</span>
        </div>
        <div className="flex justify-between">
        </div>

        {company?.VAT_certificate && (
          <div style={{ "marginTop": "2.5%" }} className="text-white text-left flex sm:justify-end">
            <span className="text-f14">
              <Link
                to={company?.VAT_certificate}
                target="_blank"
                className="border p-2 rounded-md"
              >
                View VAT Certificate
              </Link>
            </span>
          </div>
        )}
      </div>
    </Card>
  );
};
